import React, { Component } from 'react';
import Helmet from 'react-helmet';
import map from 'lodash/map';

// import range from 'lodash/range';
import Image from '../components/Image';
import WorkNav from '../components/WorkNav';
import Loader from '../components/Loader';
import Animated from '../components/Animated';

import {
  wrapper,
  fullWidth,
  // halfWidth,
  thirdWidth,
  imageWrapper,
  textContainer,
} from '../styles';

const row1 = (image, index) => {
  return (
    <div {...fullWidth} key={`image-${index}`}>
      <Image sources={image} ratio="16x9" />
    </div>
  );
};

// const row2 = (image, index) => {
//   return (
//     <div {...halfWidth} key={`image-${index}`}>
//       <Image sources={image} ratio="16x9" />
//     </div>
//   );
// };

const row3 = (image, index) => {
  return (
    <div {...thirdWidth} key={`image-${index}`}>
      <Image sources={image} ratio="16x9" />
    </div>
  );
};

class Intergalactic extends Component {
  constructor(props) {
    super(props);
    this.state = { set1: [], set2: [] };
  }

  componentWillMount() {
    this.props.load();
    this.props.loadTheme();
  }

  render() {
    const { intergalactic } = this.props;
    if (!intergalactic || !intergalactic.images) {
      return <Loader />;
    }

    const { prev, next } = this.props;
    const { images } = intergalactic;
    return (
      <div>
        <Helmet
          title="Intergalactic: A generative-art/photographic/costume-maker collaboration by Wendi Anderson and lucastswick"
          description="I projected generative art onto my costume maker/wife and shot the whole thing through a glass prism."
          meta={[
            {
              property: 'og:image:url',
              content: `https://generativeartist.com${images[23][0].srcSet}`,
            },
            {
              property: 'twitter:image',
              content: `https://generativeartist.com${images[23][0].srcSet}`,
            },
          ]}
        />
        <div {...textContainer}>
          <Animated as="h1">Intergalactic</Animated>
          <Animated delay={150}>
            Intergalactic is a generative-art/photographic/costume-maker
            collaboration between my amazing wife{' '}
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://www.wanderingwonton.me/"
            >
              Wendi Anderson
            </a>{' '}
            and myself.
          </Animated>
          <Animated>
            I projected some of my generative art onto Wendi. Her costume's
            intricate details were aligned and made more complex by the
            generative art. I then shot her through a glass prism, which created
            another layer of complexity.
          </Animated>
          <div {...imageWrapper}>{row1(images[23], 0)}</div>
          <Animated as="h2">It's all in-camera</Animated>
          <Animated>
            These are all shot in-camera. No post-processing was performed,
            except for some minor color correction. The 'effects' are the result
            of shooting through the glass prism, which refracts light and
            creates chimerical layers.
          </Animated>
        </div>
        <div {...wrapper}>
          {map(images, (image, index) => {
            if (index % 4 === 0) {
              return row1(image, index);
            } else {
              if (index < images.length - 4) {
                return row3(image, index);
              } else if (index === images.length - 1) {
                // skip last one
              } else if (index >= images.length - 3) {
              }
            }
          })}
        </div>
        <div {...textContainer}>
          <Animated>
            I'm very pleased with the outcome. It's often difficult to marry
            such different artforms, but the final output is made richer by the
            elegance of Wendi's costume composed with the dream-like distortion
            of the glass prism.
          </Animated>
          <Animated as="h2" delay={150}>
            Collaborate
          </Animated>
          <Animated delay={300}>
            I can't wait to explore this concept further. If you're a
            costume-maker, live-performer or musician, hit me up on{' '}
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://instagram.com/lucastswick"
            >
              Instagram{' '}
            </a>{' '}
            or{' '}
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://twitter.com/lucastswick"
            >
              Twitter
            </a>{' '}
            and maybe we can collaborate!
          </Animated>
        </div>

        <WorkNav prev={prev} next={next} />
      </div>
    );
  }
}

export default Intergalactic;



// WEBPACK FOOTER //
// ./src/pages/Intergalactic.js